import React, { useState, useEffect } from "react";

import "../../App.css";
import Select, { components } from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import TalentCalendarApi from "../pages/Talent/TalentCalendarApi";
import DatePicker from "react-datepicker";
import { bookingService, talentService, userService, companyService, emailService } from "../../api/apiService";
import { websocketService } from "../../services/websocketService";

// Define inline SVG icons
const SVG_ICONS = {
  calendar: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>`,
  close: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>`,
  select: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>`
};

function ProposeTalentsBookingDetail() {
  const [skipEffect, setSkipEffect] = useState(false);
  const navigate = useNavigate();
  const [similarBookings, setSimilarBookings] = useState([]);
  const [search, setSearch] = useState("");
  const [sortOrder, setSortOrder] = useState(true); 
  const [companies, setCompanies] = useState([]);
  const [talents, setTalents] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedTalentdet, setSelectedTalentdet] = useState(null);
  const [selectedTalent, setSelectedTalent] = useState(null);
  const [selectedTalentName, setSelectedTalentName] = useState(null);
  const [selectedTalentEmail, setSelectedTalentEmail] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState("");
  const [bookingDetails, setBookingDetails] = useState(null);
  const [selectedCostCenter, setSelecedCostcenter] = useState(null);
  const [selectedCostCentertwo, setSelecedCostcentertwo] = useState(null);
  const [editingbokkingTalentid, setEditingbookingTalentid] = useState("");
  const [editingbookingCompany, setEditingbookingcompany] = useState("");
  const [loading, setLoading] = useState(true);
  const [kpi, setKpi] = useState("KPI");
  const [set, setSet] = useState(""); // Start with no set filter to show all talents
  const [position, setPosition] = useState("");
  const [bookinglocation, setbookinglocation] = useState("");
  const [selectedType, setSelectedType] = useState("");
  const [selectedFunction, setSelectedFunction] = useState();
  const location = useLocation();
  const bookingId = new URLSearchParams(location.search).get("bookingId");
  const [groupID, setGroupID] = useState(
    new URLSearchParams(location.search).get("group")
  );
  const [times, setTimes] = useState("");
  const [groupColor, setgroupColor] = useState("");
  const [selectedPosition, setselectedPosition] = React.useState(null);
  const [selectedbookingoption, setselectedbookingoptions] = useState();
  const [recipientId, setRecipientId] = useState("");
  const [message, setMessage] = useState("");
  const [scheduledTime, setScheduledTime] = useState(new Date());
  const [allbookingdata, setallbookingdata] = useState();
  const [choosedTalentAllData, setchoosedTalentAllData] = useState();
  const [locations, setLocations] = useState([]);
  const [selectLocations, setSelectedLocations] = useState("");
  const [customDayRate, setCustomDayRate] = useState(null);
  const [customDayRateCheck, setCustomDayRateCheck] = useState(false);
  const [samegroupbooking, setSamegroupbooking] = useState([]);
  const [isChecked1, setIsChecked1] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const [isChecked3, setIsChecked3] = useState(false);
  const [selectionNotification, setSelectionNotification] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [processingUser, setProcessingUser] = useState(null);
  
  // CSS styles for selected talent
  const selectedTalentStyle = {
    backgroundColor: "#e3faef", 
    borderLeft: "4px solid #37b24d",
    paddingLeft: "10px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.1)"
  };
  
  // Helper function to check if a talent is selected
  const isTalentSelected = (talentId) => {
    return selectedTalent === talentId;
  };

  const isTimeIn30MinInterval = (time) => {
    return new Date(time).getMinutes() % 30 === 0;
  };

  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);

    return currentDate.getTime() < selectedDate.getTime();
  };

  //const scheduledAt = Timestamp.fromDate(new Date(scheduledTime));

  // Add a helper method to handle notifications through userService
  const createNotification = async (notificationData) => {
    try {
      // Check if userService has a createNotification method, if not, use a fallback
      if (userService.createNotification) {
        return await userService.createNotification(notificationData);
      } else {
        // Log the notification intent but provide a fallback mechanism
       // //console.log("Notification would be created:", notificationData);
        // Simulate successful notification creation
        return { 
          data: { 
            success: true, 
            message: "Notification created (simulated)", 
            notification: notificationData 
          } 
        };
      }
    } catch (error) {
    //  console.error("Error creating notification:", error);
      // Return a simulated response to avoid breaking the app flow
      return { 
        data: { 
          success: false, 
          message: "Failed to create notification (simulated fallback)" 
        } 
      };
    }
  };

  const scheduleReminder = async () => {
    try {
      if (!isChecked1 && !isChecked2 && !isChecked3) {
        return; // No reminders to schedule
      }

      const reminderData = {
        scheduledAt: scheduledTime.toISOString(),
        createdAt: new Date().toISOString(),
        url: `admin/detail?id=${bookingId}`,
        status: "scheduled" // can be 'scheduled', 'sent', or 'cancelled'
      };

      if (isChecked1 && selectedTalentEmail) {
        // Reminder for talent
        await createNotification({
          userId: selectedTalentEmail,
          message: `A reminder to check booking ${editingbookingCompany}`,
          read: false,
          url: "talent/my-bookings-page",
          bookingId: bookingId,
          ...reminderData
        });
      }

      if (isChecked2) {
        // Reminder for planning team
        await createNotification({
          userId: "planning",
          message: `A reminder to check booking ${editingbookingCompany}`,
          read: false,
          url: "cs/proposed",
          ...reminderData
        });
      }

      if (isChecked3) {
        // Reminder for current user
        const userEmail = localStorage.getItem("userEmail");
        await createNotification({
          userId: userEmail,
          message: `A reminder to check booking ${editingbookingCompany}`,
          read: false,
          url: `admin/detail?id=${bookingId}`,
          ...reminderData
        });
      }
    } catch (error) {
      console.error("Error scheduling reminders:", error);
    }
  };

  // Set the minTime and maxTime
  const minTime = new Date();
  minTime.setHours(8, 0, 0); // 8 AM
  const maxTime = new Date();
  maxTime.setHours(19, 0, 0); // 7 PM
  const handlePostionchange = (selectedPosition) => {
    setselectedPosition(selectedPosition);
  };

  const hadleSelectedBookingOption = (selectedOption) => {
    setselectedbookingoptions(selectedOption.value);
  };

  useEffect(() => {
    // If we should skip the effect, do nothing.
    fetchlocations();
    if (skipEffect) return;

    // Function to update booking processing state
    const updateBookingProcessingState = async () => {
      try {
        await bookingService.updateBooking(bookingId, {
          isBeingProcessed: false
        });
      } catch (error) {
        console.error("Error updating booking processing state:", error);
      }
    };

    // Handler for beforeunload event.
    const onBeforeUnload = (event) => {
      event.preventDefault();
      updateBookingProcessingState();
      // For Chrome, set returnValue.
      event.returnValue = "test";
    };

    // Handler for navigation changes.
    const onNavigateAway = () => {
      updateBookingProcessingState();
    };

    // Add event listeners for unload and navigation events.
    window.addEventListener("beforeunload", onBeforeUnload);
    window.addEventListener("popstate", onNavigateAway);

    // Cleanup function to remove the event listeners.
    return () => {
      window.removeEventListener("beforeunload", onBeforeUnload);
      window.removeEventListener("popstate", onNavigateAway);
    };
  }, [skipEffect, bookingId]);

  useEffect(() => {
    // Return cleanup function that will run when the component unmounts
    // or when the location changes.
    const updateBookingProcessingState = async () => {
      try {
        await bookingService.updateBooking(bookingId, {
          isBeingProcessed: false
        });
      } catch (error) {
        console.error("Error updating booking processing state:", error);
      }
    };

    return () => {
      updateBookingProcessingState();
    };
  }, [location, bookingId]);

  useEffect(() => {
    // Initialize WebSocket connection and subscribe to booking processing updates
    const initializeWebSocket = async () => {
      if (!bookingId) return;

      websocketService.connect();
      
      // Check current processing status first
      try {
        const response = await bookingService.getProcessingStatus(bookingId);
        const status = response.data?.status || {};
        
        // If booking is already being processed by another user, alert and navigate away
     
        
        // If booking is not being processed or is being processed by current user,
        // update the booking record with numeric value 1 instead of boolean true
        await bookingService.updateBooking(bookingId, {
          is_being_processed: 1,
          processing_by: localStorage.getItem("userEmail")
        });
      } catch (error) {
        console.error('Error checking or updating processing status:', error);
        alert("Error checking booking status. Please try again.");
        navigate('/admin/newallbookings');
        return;
      }

      return () => {
        // Cleanup function to release the processing status
        if (bookingId) {
          bookingService.updateBooking(bookingId, {
            is_being_processed: 0,
            processing_by: null
          }).catch(() => {});
        }
      };
    };

    initializeWebSocket();
  }, [bookingId, navigate]);

  // Add cleanup function to remove processing status when leaving
  useEffect(() => {
    return () => {
      if (bookingId) {
        bookingService.updateBooking(bookingId, {
          is_being_processed: 0,
          processing_by: null
        }).catch(() => {});
      }
    };
  }, [bookingId]);

  // Update the checkProcessingStatus function
  const checkProcessingStatus = async () => {
    try {
      const response = await bookingService.getBookingById(bookingId);
      const booking = response.data;
      
     
      return true;
    } catch (error) {
      alert("Error checking booking status. Please try again.");
      return false;
    }
  };

  const customStyles = {
    dropdownIndicator: (provided, state) => ({
      ...provided,
      border: "none",
    }),
    control: (base) => ({
      ...base,
      width: "400px",
      borderColor: "black",
      borderWidth: "1px",
      boxShadow: "none",
      margin: "5px",
      borderRadius: "0px",
      color: "black", // Your color
      fontWeight: "700",
      height: "50px",
      textTransform: "uppercase",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "black", // Your color
      fontWeight: "700",
    }),
    input: (provided) => ({
      ...provided,
      color: "black", // Your color
      fontWeight: "700",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "black" : "inherit",
      "&:hover": { backgroundColor: state.isSelected ? "black" : "#f7f7f7" },
    }),
  };
  const constcenter1 = [
    {
      id: "714",
      label: "Post Outsourcing",
      accountNumber: "70175",
      value: "714",
    },
    {
      id: "715",
      label: "Virtual Production-Operator",
      accountNumber: "70155",
      value: "715",
    },
    { id: "716", label: "Videograf", accountNumber: "70145", value: "716" },
    { id: "717", label: "Foto Still", accountNumber: "70110", value: "717" },
    { id: "718", label: "Styling Still", accountNumber: "70111", value: "718" },
    { id: "719", label: "Foto Life", accountNumber: "70120", value: "719" },
    { id: "720", label: "Styling Life", accountNumber: "70121", value: "720" },
    {
      id: "721",
      label: "Foto-Assistenz Life",
      accountNumber: "70122",
      value: "721",
    },
    { id: "722", label: "Models", accountNumber: "70124", value: "722" },
    {
      id: "723",
      label: "Hair & Make up",
      accountNumber: "70130",
      value: "723",
    },
    { id: "724", label: "Art Direction", accountNumber: "70160", value: "724" },
    {
      id: "725",
      label: "Post Production",
      accountNumber: "70170",
      value: "725",
    },
    { id: "726", label: "Text", accountNumber: "70180", value: "726" },
    {
      id: "727",
      label: "Sonstiges Produktion",
      accountNumber: "70190",
      value: "727",
    },
    {
      id: "728",
      label: "Verpflegung Shooting",
      accountNumber: "70193",
      value: "728",
    },
    { id: "729", label: "Producing", accountNumber: "70230", value: "729" },
    { id: "730", label: "Modelbooking", accountNumber: "70240", value: "730" },
    { id: "731", label: "Art Buying", accountNumber: "70250", value: "731" },
    {
      id: "732",
      label: "Logistik/Warenaufbereitung",
      accountNumber: "70260",
      value: "732",
    },
    {
      id: "733",
      label: "Technical Support",
      accountNumber: "70270",
      value: "733",
    },
    { id: "734", label: "Setbau", accountNumber: "70280", value: "734" },
    {
      id: "735",
      label: "Account Management",
      accountNumber: "70320",
      value: "735",
    },
    {
      id: "736",
      label: "Sales/Marketing",
      accountNumber: "70440",
      value: "736",
    },
    { id: "737", label: "IT/Technik", accountNumber: "70450", value: "737" },
    {
      id: "739",
      label: "Still Operator",
      accountNumber: "70115",
      value: "739",
    },
    {
      id: "845",
      label: "Digital Operator",
      accountNumber: "70150",
      value: "845",
    },
    {
      id: "860",
      label: "AI Content Production",
      accountNumber: "70199",
      value: "860",
    },
  ];
  const constcenter2 = [
    {
      id: "738",
      label: "Kunden-übergreifend / Sonstiges",
      accountNumber: "709005",
      value: "738",
    },
    
    {
      id: "846",
      label: "Zalando zCreator",
      accountNumber: "705228",
      value: "846",
    },
    {
      id: "740",
      label: "S.Oliver Produktfoto",
      accountNumber: "700021",
      value: "740",
    },
    {
      id: "741",
      label: "Comma Produktfoto",
      accountNumber: "700031",
      value: "741",
    },
    {
      id: "742",
      label: "Liebeskind Produktfoto",
      accountNumber: "700041",
      value: "742",
    },
    {
      id: "743",
      label: "Görtz Produktfoto",
      accountNumber: "700051",
      value: "743",
    },
    {
      id: "744",
      label: "PUMA Produktfoto",
      accountNumber: "700061",
      value: "744",
    },
    {
      id: "745",
      label: "PUMA Kampagne",
      accountNumber: "700062",
      value: "745",
    },
    {
      id: "746",
      label: "TomTailor Produktfoto",
      accountNumber: "700071",
      value: "746",
    },
    {
      id: "747",
      label: "TomTailor Kamagne",
      accountNumber: "700072",
      value: "747",
    },
    {
      id: "748",
      label: "BonPrix Produktfoto",
      accountNumber: "700091",
      value: "748",
    },
    {
      id: "749",
      label: "HFG Produktfoto",
      accountNumber: "700101",
      value: "749",
    },
    { id: "750", label: "HFG Kampagne", accountNumber: "700102", value: "750" },
    {
      id: "751",
      label: "Juvia Produktfoto",
      accountNumber: "700111",
      value: "751",
    },
    {
      id: "752",
      label: "HugoBoss Produktfoto",
      accountNumber: "700121",
      value: "752",
    },
    {
      id: "753",
      label: "HugoBoss Kampagne",
      accountNumber: "700122",
      value: "753",
    },
    {
      id: "754",
      label: "Bogner Produktfoto",
      accountNumber: "700601",
      value: "754",
    },
    {
      id: "755",
      label: "Bogner Kampagne",
      accountNumber: "700602",
      value: "755",
    },
    {
      id: "756",
      label: "Heine Produktfoto",
      accountNumber: "700621",
      value: "756",
    },
    {
      id: "757",
      label: "WittWeiden Produktfoto",
      accountNumber: "705071",
      value: "757",
    },
    {
      id: "758",
      label: "Zalando EPS Produktfoto",
      accountNumber: "705141",
      value: "758",
    },
    {
      id: "759",
      label: "Zalando EPS Kampagne",
      accountNumber: "705142",
      value: "759",
    },
    {
      id: "760",
      label: "ToryBurch Produktfoto",
      accountNumber: "705171",
      value: "760",
    },
    {
      id: "761",
      label: "Falke Produktfoto",
      accountNumber: "705181",
      value: "761",
    },
    {
      id: "762",
      label: "Zalando RPDP Produktfoto",
      accountNumber: "705221",
      value: "762",
    },
    {
      id: "763",
      label: "Sonstige Kleinkunden Produktfoto",
      accountNumber: "707991",
      value: "763",
    },
    {
      id: "766",
      label: "PUMA Virtual Production",
      accountNumber: "700066",
      value: "766",
    },
    {
      id: "767",
      label: "C&A Produktfoto",
      accountNumber: "703421",
      value: "767",
    },
    { id: "768", label: "C&A Kampagne", accountNumber: "703422", value: "768" },
    {
      id: "769",
      label: "C&A Virtual Production",
      accountNumber: "703429",
      value: "769",
    },
    {
      id: "773",
      label: "Ziener Produktfoto",
      accountNumber: "705051",
      value: "773",
    },
    {
      id: "772",
      label: "Zalando EPDP Produktfoto HH",
      accountNumber: "705191",
      value: "772",
    },
    {
      id: "778",
      label: "Tommy Hilfiger Produktfoto",
      accountNumber: "740411",
      value: "778",
    },
    {
      id: "847",
      label: "z PDP ACC",
      accountNumber: "705230",
      value: "847",
    },
    {
      id: "848",
      label: "Mammut PF HH ",
      accountNumber: "700551",
      value: "848",
    },
    {
      id: "856",
      label: "TB International PF HH",
      accountNumber: "700451",
      value: "856",
    },
    {
      id: "859",
      label: "Marketplace Amplifier GmbH Produktfoto HH",
      accountNumber: "700452",
      value: "859",
    },
    {
      id: "849",
      label: "DEV - AI Character Creation",
      accountNumber: "709510",
      value: "849",
    },
    {
      id: "850",
      label: "DEV - AI Character Replacement",
      accountNumber: "709512",
      value: "850",
    },
    {
      id: "852",
      label: "DEV - AI Background Replacement",
      accountNumber: "709516",
      value: "852",
    },
    {
      id: "853",
      label: "DEV - AI Background Replacement",
      accountNumber: "709518",
      value: "853",
    },
    {
      id: "854",
      label: "DEV - Bust to on-Model",
      accountNumber: "709520",
      value: "854",
    },
    {
      id: "855",
      label: "DEV - AI Content Hub",
      accountNumber: "709522",
      value: "855",
    },
    {
      id: "861",
      label: "DEV - KIND",
      accountNumber: "709524",
      value: "861",
    },
    {
      id: "858",
      label: "New Production Line",
      accountNumber: "706010",
      value: "858",
    },
  ];

  const booking = [
    { label: "Request", value: "requested" },
    { label: "Option", value: "optioned" },
  ];
  const handleSelectCostCenter = (selectedOption) => {
    setSelecedCostcenter(selectedOption);
  };
  const handleSelectCostCentertwo = (selectedOption) => {
    setSelecedCostcentertwo(selectedOption);
  };
  const DropdownIndicator = (props) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <div style={{ width: "16px", margin: "0" }}
            dangerouslySetInnerHTML={{ __html: SVG_ICONS.select }}
          />
        </components.DropdownIndicator>
      )
    );
  };
  const DropdownIndicator2 = (props) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <div style={{ width: "16px", margin: "0" }}>
            <svg
              version="1.1"
              id="Isolationsmodus"
              x="0px"
              y="0px"
              viewBox="0 0 322.9 257.78"
              shapeRendering="geometricPrecision"
            >
              <path
                xmlns="http://www.w3.org/2000/svg"
                d="M208.27,7.37c-4.69-4.79-11.12-7.4-17.72-7.81c-0.4-0.03-0.8-0.05-1.22-0.05l0,0h-35.34h-70.2H31.14h-4.27  C17.33-0.46,7.87,4.51,3.34,13.12C-1.19,21.65-1.3,32.3,4.19,40.47c0.85,1.3,1.74,2.56,2.6,3.82C17.3,59.73,27.77,75.2,38.27,90.64  c12.47,18.33,24.91,36.7,37.39,55.03c3.08,4.53,6.13,9.02,9.21,13.54c3.97,5.86,9.06,10.5,16.08,12.36  c6.87,1.86,14.85,0.93,20.9-2.93c3.79-2.45,6.24-5.12,8.8-8.79c8.06-11.54,15.82-23.3,23.76-34.96  c13.14-19.33,26.25-38.67,39.39-57.96c4.68-6.87,9.32-13.73,14-20.63c4.31-6.31,8.39-12.13,8.2-20.41  C215.85,18.95,213.1,12.34,208.27,7.37z"
              />
            </svg>
          </div>
        </components.DropdownIndicator>
      )
    );
  };
  const fetchTalentDetails = async (talentId) => {
    try {
      if (!talentId) {
        // console.warn("Attempted to fetch talent details with invalid ID:", talentId);
        return null;
      }
      
      const response = await talentService.getTalentById(talentId);
      return response.data || null;
    } catch (error) {
      console.error(`Error fetching talent details for ID ${talentId}:`, error);
      return null;
    }
  };

  // Extract similar bookings fetch into separate function
  const fetchSimilarBookings = async (booking, startDateObj) => {
    try {
      const bookingDateString = startDateObj ? startDateObj.toISOString().split('T')[0] : null;
      // console.log("Searching for similar bookings on date:", bookingDateString);
      
      const similarBookingsResponse = await bookingService.searchBookings({
        statuses: ["optionSolved", "talentOnHold"],
        position: booking.position?.label,
        startDate: bookingDateString,
        location: booking.location?.short || booking.location?.name || booking.location,
        limit: 1000
      });
      
      // console.log("Similar bookings API response:", similarBookingsResponse);
      
      const similarBookingsData = similarBookingsResponse.data?.bookings || similarBookingsResponse.data;
      
      if (similarBookingsData && Array.isArray(similarBookingsData) && similarBookingsData.length > 0) {
        const filteredBookings = similarBookingsData.filter(similarBooking => {
          const similarDate = new Date(similarBooking.start_date);
          const similarDateString = similarDate.toISOString().split('T')[0];
          const matchesDate = bookingDateString === similarDateString;
          
          const similarPosition = similarBooking.position?.label || similarBooking.position;
          const currentPosition = booking.position?.label || booking.position;
          const matchesPosition = currentPosition === similarPosition;
          
          return matchesDate && matchesPosition;
        });
        
        const bookingsWithTalentDetails = await Promise.all(
          filteredBookings.map(async (similarBooking) => {
            try {
              const talentId = similarBooking.talentId || similarBooking.talent_id || similarBooking.talentId;
              
              if (talentId) {
                let talentResponse = await talentService.getTalentById(talentId);
                
                if (!talentResponse || !talentResponse.data) {
                  const allTalentsResponse = await talentService.getAllTalents(1, 5000);
                  const allTalents = allTalentsResponse?.data?.talents || [];
                  
                  const talentByFirebaseId = allTalents.find(talent => 
                    talent.firebase_id === talentId || talent.firebaseId === talentId
                  );
                  
                  if (talentByFirebaseId) {
                    talentResponse = { data: talentByFirebaseId };
                  }
                }
                
                let talent = null;
                if (talentResponse?.data?.talent) {
                  talent = talentResponse.data.talent;
                } else if (talentResponse?.data?.Name || talentResponse?.data?.name) {
                  talent = talentResponse.data;
                } else if (talentResponse?.talent) {
                  talent = talentResponse.talent;
                } else if (talentResponse?.data) {
                  talent = talentResponse.data;
                }
                
                return {
                  ...similarBooking,
                  talentId: talentId,
                  talentName: talent?.Name || talent?.name || "Unknown",
                  talentEmail: talent?.E_Mail || talent?.email || "Unknown",
                  talentRate: talent?.Tagessatz || talent?.daily_rate || "Unknown"
                };
              } else {
                return {
                  ...similarBooking,
                  talentId: null,
                  talentName: "No Talent Assigned",
                  talentEmail: "N/A",
                  talentRate: "N/A"
                };
              }
            } catch (error) {
              console.error("Error fetching talent details:", error);
              return {
                ...similarBooking,
                talentId: similarBooking.talentId || similarBooking.talent_id,
                talentName: "Error Fetching Talent",
                talentEmail: "Error",
                talentRate: "Error"
              };
            }
          })
        );
        
        // console.log("Final similar bookings with talent details:", bookingsWithTalentDetails);
        setSimilarBookings(bookingsWithTalentDetails);
      } else {
        // console.log("No similar bookings found with the specified criteria");
        setSimilarBookings([]);
      }
    } catch (error) {
      console.error("Error fetching similar bookings:", error);
      setSimilarBookings([]);
    }
  };
  useEffect(() => {
    // Fetch booking details first (priority), then companies and talents
    const fetchBookingDetailsFirst = async () => {
        if (bookingId) {
          try {
            const response = await bookingService.getBookingById(bookingId);
            const booking = response.data;

            // Update booking with processing status and user info
            await bookingService.updateBooking(bookingId, {
              is_being_processed: true,
              processing_by: localStorage.getItem("userEmail")
            });

            // Also notify the processing status endpoint
            try {
              await bookingService.startProcessing(bookingId);
            } catch (error) {
              // If the processing endpoint fails, we still have the main booking update as fallback
            if (error.response?.status === 409) {
              // console.warn("Booking is already being processed by another user");
            } else if (error.response?.status === 400) {
              console.error("Error starting processing:", error.response?.data?.message || "Unknown error");
            } else {
              console.error("Unexpected error starting processing:", error);
            }
          }
          
          // Set booking details immediately
          setBookingDetails(booking);
          setallbookingdata(booking);
          setgroupColor(booking.groupColor);
          const clientName = booking.client?.label || '';
          // console.log('DEBUG - Setting editingbookingCompany to:', clientName);
          setEditingbookingcompany(clientName);
          setSet(booking.set);
          
          // Convert KPI to integer to avoid decimal display
          const kpiValue = booking.kpi;
          if (kpiValue !== null && kpiValue !== undefined && kpiValue !== '') {
            const numericKpi = parseFloat(kpiValue);
            if (!isNaN(numericKpi)) {
              setKpi(Math.floor(numericKpi).toString());
            } else {
              setKpi(kpiValue.toString());
            }
          } else {
            setKpi('');
          }
          
          setPosition(booking.position?.label || '');
          setStatus(booking.status);
          
          // Extract location for display
          let locationDisplay = '';
          if (booking.set === "digital Production") {
            // KIND orders: show "K.I.N.D." as location
            locationDisplay = 'K.I.N.D.';
          } else {
            // Regular bookings: extract from location object
            locationDisplay = booking.location?.short || booking.location?.name || 
                            (typeof booking.location === 'object' ? 
                             JSON.stringify(booking.location) : booking.location) || '';
          }
          setbookinglocation(locationDisplay);
          
          // For KIND orders (set = "digital Production"), don't filter by location
          // KIND orders are remote/office-based, not city-based, so we want to show all talents
          if (booking.set === "digital Production") {
            setSelectedLocations(''); // Clear location filter for KIND orders
          } else {
            // Use short property for selection if available
            if (booking.location) {
              if (typeof booking.location === 'object') {
                setSelectedLocations(booking.location.short || booking.location.name || '');
              } else {
                setSelectedLocations(booking.location || '');
              }
            }
          }
          
          setSelectedFunction(booking.position?.label || '');
          // console.log("📍 Position set for booking:", booking.position?.label);
          // console.log("📍 Set for booking:", booking.set);
          setGroupID(booking.group);
          
          const startDateObj = booking.start_date ? new Date(booking.start_date) : null;
          const endDateObj = booking.end_date ? new Date(booking.end_date) : null;
          
          setStartDate(startDateObj ? startDateObj.toLocaleDateString() : '');
          setEndDate(endDateObj ? endDateObj.toLocaleDateString() : '');
          setTimes(`${booking.start_time || ''}-${booking.end_time || ''}`);
          
          // Fetch similar bookings immediately after booking details
          await fetchSimilarBookings(booking, startDateObj);
          
          // Fetch bookings with the same group ID
          if (booking.group) {
            fetchBookingsByGroup(booking.group);
          }
          
          } catch (error) {
          console.error("Error fetching booking details:", error);
            alert("Error checking booking status. Please try again.");
            navigate('/admin/newallbookings');
            return;
          }
        }
    };
    
    // Fetch companies and talents in background
    const fetchCompaniesAndTalents = async () => {
      try {
        let companyData = [];
        let talentData = [];
        
        // Try to fetch companies, but use fallbacks if endpoint isn't available
        try {
          const companyResponse = await companyService.getAllCompanies();
          if (companyResponse && companyResponse.data) {
            // Handle different response formats
            let companiesArray = [];
            
            if (Array.isArray(companyResponse.data)) {
              // Direct array format
              companiesArray = companyResponse.data;
            } else if (companyResponse.data.companies && Array.isArray(companyResponse.data.companies)) {
              // Nested companies array format
              companiesArray = companyResponse.data.companies;
            } else {
              // console.warn("Unexpected companies data format:", companyResponse.data);
              companiesArray = [];
            }
            
            if (companiesArray.length > 0) {
              companyData = companiesArray.map((company) => ({
              value: company.id,
              label: company.name,
            }));
            } else {
              // Empty array fallback
              companyData = [];
            }
          }
        } catch (error) {
          console.error("Error fetching companies:", error);
          // Fallback company data
          companyData = [
            { value: "1", label: "Company 1" },
            { value: "2", label: "Company 2" },
            { value: "3", label: "Company 3" }
          ];
        }
        
        // Try to fetch talents, but use fallbacks if endpoint isn't available
        try {
          // Initialize an array to hold all talents
          let allTalents = [];
          let page = 1;
          const limit = 1000; // Increase limit to 1000 to fetch more talents at once
          let hasMoreTalents = true;

          // Fetch talents with pagination until all are retrieved
          while (hasMoreTalents) {
            // console.log(`Fetching talents page ${page} with limit ${limit}...`);
            
            // Specify the 'talents' endpoint directly to avoid '/talents/undefined' issue
            const talentResponse = await talentService.getAllTalents(1, 1000, {});
            
            // Check if response has the new format with talents in a data.talents property
            // or the previous format with talents directly in data
            const talentsData = talentResponse?.data?.talents || talentResponse?.data;
            
            if (Array.isArray(talentsData) && talentsData.length > 0) {
              allTalents = [...allTalents, ...talentsData];
              // console.log(`Added ${talentsData.length} talents. Total so far: ${allTalents.length}`);
              
              // Check if we've reached the end
              if (talentsData.length < limit) {
                hasMoreTalents = false;
                // console.log("Reached end of talents (received fewer than limit)");
              } else {
                page++;
              }
            } else {
              // No more talents or unexpected format
              // console.log("No more talents found or unexpected format:", talentsData);
              hasMoreTalents = false;
            }
          }
          
          // console.log(`Retrieved ${allTalents.length} talents in total`);
          
          if (allTalents.length > 0) {
            try {
                // Process talents in batches to get their company data
                const batchSize = 1200;
                const enhancedTalentsData = [];
                
                for (let i = 0; i < allTalents.length; i += batchSize) {
                  const batch = allTalents.slice(i, i + batchSize);
                  
                  const batchResults = await Promise.all(batch.map(async (talent) => {
                    try {
                      // Try to get company data from the new endpoint
                      const companyResponse = await talentService.getTalentCompanies(talent.id);
                      
                      if (companyResponse && companyResponse.data) {
                        const companyData = companyResponse.data;
                        
                        return {
                value: talent.id,
                          Name: talent.Name || talent.name,
                          E_Mail: talent.E_Mail || talent.email,
                          Funktion: talent.Funktion || talent.function,
                          Tagessatz: talent.Tagessatz || talent.rate,
                          Bereich: talent.Bereich || talent.type || talent.bereich,
                          goodPerformanceCompany: companyData.goodPerformanceCompany || talent.goodPerformanceCompany || [],
                          badPerformanceCompany: companyData.badPerformanceCompany || talent.badPerformanceCompany || [],
                          tryOutCompany: companyData.tryOutCompany || talent.tryOutCompany || [],
                alldata: talent,
                          relatedTalent: talent.relatedTalent || [],
                          locations: talent.locations || [],
                        };
                      }
                      
                      // Fallback to original talent data
                      return {
                        value: talent.id,
                        Name: talent.Name || talent.name,
                        E_Mail: talent.E_Mail || talent.email,
                        Funktion: talent.Funktion || talent.function,
                        Tagessatz: talent.Tagessatz || talent.rate,
                        Bereich: talent.Bereich || talent.type || talent.bereich,
                        goodPerformanceCompany: talent.goodPerformanceCompany || [],
                        badPerformanceCompany: talent.badPerformanceCompany || [],
                        tryOutCompany: talent.tryOutCompany || [],
                        alldata: talent,
                        relatedTalent: talent.relatedTalent || [],
                        locations: talent.locations || [],
                      };
                    } catch (error) {
                      // console.warn(`Could not fetch company data for talent ${talent.id}:`, error);
                      // Return talent data without enhanced company information
                      return {
                        value: talent.id,
                        Name: talent.Name || talent.name,
                        E_Mail: talent.E_Mail || talent.email,
                        Funktion: talent.Funktion || talent.function,
                        Tagessatz: talent.Tagessatz || talent.rate,
                        Bereich: talent.Bereich || talent.type || talent.bereich,
                        goodPerformanceCompany: talent.goodPerformanceCompany || [],
                        badPerformanceCompany: talent.badPerformanceCompany || [],
                        tryOutCompany: talent.tryOutCompany || [],
                        alldata: talent,
                        relatedTalent: talent.relatedTalent || [],
                        locations: talent.locations || [],
                      };
                    }
                  }));
                  
                  enhancedTalentsData.push(...batchResults);
                  
                  // Add a small delay between batches (reduced since batches are much larger now)
                  if (i + batchSize < allTalents.length) {
                    await new Promise(resolve => setTimeout(resolve, 50));
                  }
                }
                
                talentData = enhancedTalentsData;
            } catch (error) {
              console.error("Error mapping talent data:", error);
                // Fallback to basic mapping
                talentData = allTalents.map((talent) => ({
                  value: talent.id,
                  Name: talent.Name || talent.name,
                  E_Mail: talent.E_Mail || talent.email,
                  Funktion: talent.Funktion || talent.function,
                  Tagessatz: talent.Tagessatz || talent.rate,
                  Bereich: talent.Bereich || talent.type || talent.bereich,
                  goodPerformanceCompany: talent.goodPerformanceCompany || [],
                  badPerformanceCompany: talent.badPerformanceCompany || [],
                  tryOutCompany: talent.tryOutCompany || [],
                  alldata: talent,
                  relatedTalent: talent.relatedTalent || [],
                  locations: talent.locations || [],
                }));
            }
          }
        } catch (error) {
          console.error("Error fetching talents:", error);
          // Fallback talent data
          talentData = [
            { 
              value: "1", 
              Name: "Talent 1",
              E_Mail: "talent1@example.com",
              Funktion: "Function 1",
              Tagessatz: "500",
              Bereich: "Area 1",
              goodPerformanceCompany: [],
              badPerformanceCompany: [],
              alldata: { Name: "Talent 1", E_Mail: "talent1@example.com" },
              relatedTalent: [],
              tryOutCompany: [],
              locations: []
            },
            { 
              value: "2", 
              Name: "Talent 2",
              E_Mail: "talent2@example.com",
              Funktion: "Function 2",
              Tagessatz: "600",
              Bereich: "Area 2",
              goodPerformanceCompany: [],
              badPerformanceCompany: [],
              alldata: { Name: "Talent 2", E_Mail: "talent2@example.com" },
              relatedTalent: [],
              tryOutCompany: [],
              locations: []
            }
          ];
        }

        // Set companies first
        setCompanies(companyData);
        
        // Set all talents at once (they're already enhanced with company data)
        // console.log(`Setting ${talentData.length} talents`);
        // console.log('Filter states:', { set, selectedFunction, selectLocations, search });
        
        // Debug: Log talents with AI Content Production function
        const aiContentTalents = talentData.filter(t => t.Funktion === "AI Content Production");
        // console.log(`🎯 Talents with "AI Content Production":`, aiContentTalents.length);
        if (aiContentTalents.length > 0) {
          // console.log("Sample AI Content Production talent:", aiContentTalents[0]);
        }
        
        // Log all unique Funktion values
        const uniqueFunktions = [...new Set(talentData.map(t => t.Funktion).filter(Boolean))];
        // console.log("📋 All unique Funktion values:", uniqueFunktions);
        
        setTalents(talentData);
                    } catch (error) {
        console.error("Error fetching companies and talents:", error);
      }
    };
    
    // Execute in priority order
    fetchBookingDetailsFirst().then(() => {
      setLoading(false); // Booking details loaded, show UI
    });
    
    // Fetch companies and talents in background
    fetchCompaniesAndTalents();
  }, [bookingId, navigate]);

  // Add cleanup function to remove processing status when leaving
  useEffect(() => {
    return () => {
      if (bookingId) {
        bookingService.updateBooking(bookingId, {
          is_being_processed: false,
          processing_by: null
        }).catch(() => {});
      }
    };
  }, [bookingId]);

  const handleTalentChange = (selectedOption) => {
    setSelectedTalent(selectedOption);
  };
  const createmail = async (TalentName, allbookingdata, choosedTalentAllData) => {
    try {
      const rate = customDayRate || choosedTalentAllData.Tagessatz;
      
      const emailData = {
     
        to_email: `booking@set-cast.com, talent@mondula.com, ${localStorage.getItem("userEmail")}`,
        subject: "Talent has been proposed",
        content: `
          <h2>Dear Team,</h2>
          <p>A new Invitation has been sent to ${TalentName}</p>
          <p>StartDate: ${startDate}</p>
          <p>End Date: ${allbookingdata.endDate}</p>
          <p>Freelancer: ${TalentName}</p>
          <p>Company: ${allbookingdata.client?.label}</p>
          <p>Position: ${allbookingdata.position?.label}</p>
          <p>Rate: ${rate}</p>
          <p>Check all the booking in <a href="https://app.set-cast.com/">https://app.set-cast.com/</a></p>
        `
      };
      
      return await emailService.sendEmail(emailData);
    } catch (error) {
      console.error("Error sending email:", error);
      alert(`Email Error:\n${error.message}`);
      throw error;
    }
  };

  const createmail2g = async (TalentName, allbookingdata, choosedTalentAllData, emailContent) => {
    try {
      const emailData = {
      
        to_email: `talents@set-cast.com, booking@set-cast.com, ${localStorage.getItem("userEmail")}, ${choosedTalentAllData.E_Mail}`,
        subject: `1.OPTION REQUEST ${allbookingdata.client?.label} - ${TalentName} - ${startDate}`,
        content: `
          <h2>Dear ${TalentName},</h2>
          <p>Hope your day is fine. May I have your first option for:</p>
          ${emailContent}
          <p>SETCast contact person: ${localStorage.getItem("userEmail") || 'Not specified'}</p>
                    <p>In case of illness or delay, please send an email directly to the distribution list planning@orendtstudios.com and krank@set-cast.com by 8:00 a.m. at the latest.</p>
          <p>Please make sure to inform Set-Cast and the producer of the production if you need to leave the set early and double check with the producer if the KPI has been reached.</p>
          <p>For questions regarding KPI, shooting schedules, callsheets and briefings, please contact planning@orendtstudios.com.</p>
          <p>Invoice details:</p>
          <p>please upload your invoice in Lano - you could combine several tasks in one invoice</p>
          <p>LEGENDE:</p>
          <p>B28 = Behringstrasse 28a, 22765 Hamburg</p>
          <p>TR4 = Tarpenring 4, 22419 Hamburg</p>
          <p>M= Holy-Allee 3, Metzingen, am Empfang melden</p>
          <p>OSB= Am Rosenkothen 2, 40880 Ratingen</p>
            <p>EB5 = Essener Bogen 5, 22419 Hamburg</p>
          <p>Accept or deny your bookings in <a href="https://app.set-cast.com/talent/my-invitations">https://app.set-cast.com/talent/my-invitations</a></p>
          <p>Accept or deny on behalf of talent (For SetCast) <a href="https://app.set-cast.com/admin/requested">https://app.set-cast.com/admin/requested</a></p>
        `
      };
      
      return await emailService.sendEmail(emailData);
    } catch (error) {
      console.error("Error sending email:", error);
      alert(`Email Error:\n${error.message}`);
      throw error;
    }
  };

  const createmail2 = async (TalentName, allbookingdata, choosedTalentAllData) => {
    try {
      const rate = customDayRate || choosedTalentAllData.Tagessatz;
      
      const emailData = {
  
        to_email: `talents@set-cast.com, booking@set-cast.com, ${localStorage.getItem("userEmail")}, ${choosedTalentAllData.E_Mail}`,
        subject: `1.OPTION REQUEST ${allbookingdata.client?.label} - ${TalentName} - ${startDate}`,
        content: `
          <h2>Dear ${TalentName},</h2>
          <p>Hope your day is fine. May I have your first option for:</p>
          <p>STATUS: 1ST OPTION REQUEST</p>
          <p>FUNCTION: ${allbookingdata.position?.label}</p>
          <p>CLIENT: ${allbookingdata.client?.label}</p>
          <p>Set: ${set}</p>
          <p>DATE/PERIOD: ${startDate}</p>
          <p>TIME: ${times}</p>
          <p>DAYRATE: ${rate}</p>
          <p>KPI: ${(() => {
            const kpiValue = kpi;
            if (kpiValue === null || kpiValue === undefined || kpiValue === '') {
              return 'Not specified';
            }
            
            // Handle objects (like location objects that might be in the wrong field)
            if (typeof kpiValue === 'object' && kpiValue !== null) {
              return 'Not specified';
            }
            
            // Convert to number and round to integer
            const numericValue = parseFloat(kpiValue);
            if (!isNaN(numericValue)) {
              return Math.round(numericValue);
            }
            
            // If it's not a valid number, return 'Not specified'
            return 'Not specified';
          })()}</p>
          <p>LOCATION: ${bookinglocation}</p>
          <p>SETCast contact person: ${localStorage.getItem("userEmail") || 'Not specified'}</p>
                    <p>In case of illness or delay, please send an email directly to the distribution list planning@orendtstudios.com and krank@set-cast.com by 8:00 a.m. at the latest.</p>
          <p>Please make sure to inform Set-Cast and the producer of the production if you need to leave the set early and double check with the producer if the KPI has been reached.</p>
          <p>For questions regarding KPI, shooting schedules, callsheets and briefings, please contact planning@orendtstudios.com.</p>
          <p>Invoice details:</p>
          <p>please upload your invoice in Lano - you could combine several tasks in one invoice</p>
          <p>LEGENDE:</p>
          <p>B28 = Behringstrasse 28a, 22765 Hamburg</p>
          <p>TR4 = Tarpenring 4, 22419 Hamburg</p>
          <p>M= Holy-Allee 3, Metzingen, am Empfang melden</p>
          <p>OSB= Am Rosenkothen 2, 40880 Ratingen</p>
            <p>EB5 = Essener Bogen 5, 22419 Hamburg</p>
          <p>Accept or deny your bookings in <a href="https://app.set-cast.com/talent/my-invitations">https://app.set-cast.com/talent/my-invitations</a></p>
          <p>Accept or deny on behalf of talent (For SetCast) <a href="https://app.set-cast.com/admin/requested">https://app.set-cast.com/admin/requested</a></p>
        `
      };
      
      return await emailService.sendEmail(emailData);
    } catch (error) {
      console.error("Error sending email:", error);
      alert(`Email Error:\n${error.message}`);
      throw error;
    }
  };

  const createmail3 = async (TalentName, allbookingdata, choosedTalentAllData) => {
    try {
      const rate = customDayRate || choosedTalentAllData.Tagessatz;

      const emailData = {
    
        to_email: `talents@set-cast.com, ${choosedTalentAllData.E_Mail}`,
        subject: `1. OPTION - ${allbookingdata.client?.label} - ${TalentName} - ${startDate}`,
        content: `
          <h2>Dear ${TalentName},</h2>
          <p>as we have just discussed on the phone, I have noted the 1st option on you for the following production:</p>
          <p>STATUS: 1ST OPTION</p>
          <p>FUNCTION: ${allbookingdata.position?.label}</p>
          <p>CLIENT: ${allbookingdata.client?.label}</p>
          <p>Set: ${set}</p>
          <p>DATE/PERIOD: ${startDate}</p>
          <p>TIME: ${times}</p>
          <p>DAYRATE: ${rate}</p>
          <p>KPI: ${(() => {
            const kpiValue = kpi;
            if (kpiValue === null || kpiValue === undefined || kpiValue === '') {
              return 'Not specified';
            }
            
            // Handle objects (like location objects that might be in the wrong field)
            if (typeof kpiValue === 'object' && kpiValue !== null) {
              return 'Not specified';
            }
            
            // Convert to number and round to integer
            const numericValue = parseFloat(kpiValue);
            if (!isNaN(numericValue)) {
              return Math.round(numericValue);
            }
            
            // If it's not a valid number, return 'Not specified'
            return 'Not specified';
          })()}</p>
          <p>LOCATION: ${bookinglocation}</p>
          <p>SETCast contact person: ${localStorage.getItem("userEmail") || 'Not specified'}</p>
                    <p>In case of illness or delay, please send an email directly to the distribution list planning@orendtstudios.com and krank@set-cast.com by 8:00 a.m. at the latest.</p>
          <p>Please make sure to inform Set-Cast and the producer of the production if you need to leave the set early and double check with the producer if the KPI has been reached.</p>
          <p>For questions regarding KPI, shooting schedules, callsheets and briefings, please contact planning@orendtstudios.com.</p>
          <p>Invoice details:</p>
          <p>please upload your invoice in Lano - you could combine several tasks in one invoice</p>
          <p>LEGENDE:</p>
          <p>B28 = Behringstrasse 28a, 22765 Hamburg</p>
          <p>TR4 = Tarpenring 4, 22419 Hamburg</p>
          <p>M= Holy-Allee 3, Metzingen, am Empfang melden</p>
          <p>OSB= Am Rosenkothen 2, 40880 Ratingen</p>
            <p>EB5 = Essener Bogen 5, 22419 Hamburg</p>
          <p>Check all your bookings in <a href="https://app.set-cast.com/talent/my-invitations">https://app.set-cast.com/talent/my-invitations</a></p>
        `
      };
      
      return await emailService.sendEmail(emailData);
    } catch (error) {
      console.error("Error sending email:", error);
      alert(`Email Error:\n${error.message}`);
      throw error;
    }
  };

  const createmail3g = async (TalentName, allbookingdata, choosedTalentAllData, emailContent) => {
    try {
      const emailData = {

        to_email: `talents@set-cast.com, ${choosedTalentAllData.E_Mail}`,
        subject: `1. OPTION - ${allbookingdata.client?.label} - ${TalentName} - ${startDate}`,
        content: `
          <h2>Dear ${TalentName},</h2>
          <p>as we have just discussed on the phone, I have noted the 1st option on you for the following production:</p>
          ${emailContent}
          <p>SETCast contact person: ${localStorage.getItem("userEmail") || 'Not specified'}</p>
                    <p>In case of illness or delay, please send an email directly to the distribution list planning@orendtstudios.com and krank@set-cast.com by 8:00 a.m. at the latest.</p>
          <p>Please make sure to inform Set-Cast and the producer of the production if you need to leave the set early and double check with the producer if the KPI has been reached.</p>
          <p>For questions regarding KPI, shooting schedules, callsheets and briefings, please contact planning@orendtstudios.com.</p>
          <p>Invoice details:</p>
          <p>please upload your invoice in Lano - you could combine several tasks in one invoice</p>
          <p>LEGENDE:</p>
          <p>B28 = Behringstrasse 28a, 22765 Hamburg</p>
          <p>TR4 = Tarpenring 4, 22419 Hamburg</p>
          <p>M= Holy-Allee 3, Metzingen, am Empfang melden</p>
          <p>OSB= Am Rosenkothen 2, 40880 Ratingen</p>
            <p>EB5 = Essener Bogen 5, 22419 Hamburg</p>
          <p>Check all your bookings in <a href="https://app.set-cast.com/talent/my-invitations">https://app.set-cast.com/talent/my-invitations</a></p>
        `
      };
      
      return await emailService.sendEmail(emailData);
    } catch (error) {
      console.error("Error sending email:", error);
      alert(`Email Error:\n${error.message}`);
      throw error;
    }
  };
  const checkForBookingConflicts = async (startDate, endDate, talentId, excludeBookingId) => {
    try {
      // Convert dates to ISO format
      const startISO = new Date(startDate).toISOString();
      const endISO = new Date(endDate).toISOString();
      
      // Search for bookings with the given talent ID in the date range
      const response = await bookingService.searchBookings({
        talentId: talentId,
        startDateRange: startISO,
        endDateRange: endISO
      });
      
      // Check if the response.data has a 'bookings' property (new API format)
      const bookingsData = response.data?.bookings || response.data;
      
      // Filter out the current booking if an ID is provided
      if (Array.isArray(bookingsData)) {
        const conflictingBookings = bookingsData.filter(booking => booking.id !== excludeBookingId);
        return conflictingBookings.length > 0;
      } else {
        // console.warn("Unexpected bookings data format:", response.data);
        return false;
      }
    } catch (error) {
      console.error("Error checking for booking conflicts:", error);
      return false;
    }
  };

  const fetchBookingsByGroup = async (groupId) => {
    if (!groupId) {
      setSamegroupbooking([]);
      return;
    }
    
    try {
      const response = await bookingService.searchBookings({ group: groupId });
      
      if (response && response.data) {
        // Check if the response.data has a 'bookings' property (new API format)
        const bookingsArray = response.data.bookings || response.data;
        
        if (Array.isArray(bookingsArray)) {
          const bookings = bookingsArray.map(booking => ({
            id: booking.id || Math.random().toString(),
            ...booking
          }));
          
          setSamegroupbooking(bookings);
        } else {
          // console.warn("Bookings data is not an array:", bookingsArray);
          setSamegroupbooking([]);
        }
      } else {
        // console.warn("No bookings data returned from API for group:", groupId);
        setSamegroupbooking([]);
      }
    } catch (error) {
      console.error("Error fetching bookings by group:", error);
      setSamegroupbooking([]);
    }
  };

  const getallBookingsWithGroupId = async (groupId) => {
    if (!groupId) {
      return [];
    }
    
    try {
      const response = await bookingService.searchBookings({ group: groupId });
      
      if (response && response.data) {
        // Check if the response.data has a 'bookings' property (new API format)
        const bookingsArray = response.data.bookings || response.data;
        
        if (Array.isArray(bookingsArray)) {
          return bookingsArray.map(booking => ({
            id: booking.id || Math.random().toString(),
            ...booking
          }));
        } else {
          // console.warn("Bookings data is not an array:", bookingsArray);
          return [];
        }
      } else {
        // console.warn("No bookings data returned from API for group:", groupId);
        return [];
      }
    } catch (error) {
      console.error("Error fetching all bookings by group:", error);
      return [];
    }
  };

  const updateBookingWithGroupId = async (groupId, newData, TalentName, choosedTalentAllData) => {
    try {
      const bookings = await getallBookingsWithGroupId(groupId);
      
      for (const booking of bookings) {
        await bookingService.updateBooking(booking.id, newData);
      }
      
      setallbookingdata(newData);
    } catch (error) {
      console.error("Error updating bookings with group ID:", error);
    }
  };
  
  const createGroupEmailContent = async (bookings) => {
    let emailContent = " ";
    let datesContent = bookings.map(booking => {
      const startDate = new Date(booking.start_date);
      return startDate.toLocaleDateString();
    }).join(" - ");
    
    emailContent += ` ${datesContent}\n`;
    return emailContent;
  };
  
  const createEmailContentForGroupBooking = (bookings, choosedTalentAllData) => {
    const rate = customDayRate || choosedTalentAllData.Tagessatz;

    const bookingContents = bookings.map(booking => {
      const startDateFormatted = new Date(booking.start_date).toLocaleDateString();
      const endDateFormatted = new Date(booking.end_date).toLocaleDateString();
      
      return `
        <p> STATUS: 1ST OPTION </p>
        <p> FUNCTION: ${booking.position?.label} </p>
        <p> CLIENT: ${booking.client?.label} </p>
        <p> Set: ${booking.set} </p>
        <p> DATES/PERIOD: ${startDateFormatted} 
        <p> TIME: ${booking.start_time || booking.startTime || 'Not specified'} - ${booking.end_time || booking.endTime || 'Not specified'} </p>
        <p> DAYRATE: ${rate} </p> 
        <p> KPI: ${(() => {
          const kpiValue = booking.kpi;
          if (kpiValue === null || kpiValue === undefined || kpiValue === '') {
            return 'Not specified';
          }
          
          // Handle objects (like location objects that might be in the wrong field)
          if (typeof kpiValue === 'object' && kpiValue !== null) {
            return 'Not specified';
          }
          
          // Convert to number and round to integer
          const numericValue = parseFloat(kpiValue);
          if (!isNaN(numericValue)) {
            return Math.round(numericValue);
          }
          
          // If it's not a valid number, return 'Not specified'
          return 'Not specified';
        })()} </p>
        <p> LOCATION: ${booking.studio} - ${formatLocation(booking.location, booking)} </p>
      `;
    });
  
    const completeEmailContent = bookingContents.join('<hr>');
    return completeEmailContent;
  };
  
  const handleSubmit = async (e) => {
    if (!checkProcessingStatus()) {
      return;
    }

    setSkipEffect(true);
    e.preventDefault();
    
    // Check if the selections are made
    if (!selectedCostCenter || !selectedCostCentertwo) {
      alert('Please select both cost centers.');
      return;
    }
    
    // Check if it's a new booking or an update
    if (bookingId) {
      try {
        // Prepare the updated booking data
        const updatedBookingData = {
          talentId: selectedTalent,
          status: selectedbookingoption,
          costcenter1: selectedCostCenter,
          costcenter2: selectedCostCentertwo,
          proposedBy: localStorage.getItem("userEmail"),
          isBeingProcessed: false,
          statusUpdatedAt: new Date().toISOString(),
          custom_rate: customDayRate ? {
            value: parseInt(customDayRate),
            currency: "EUR",
            per: "day"
          } : null,
        };
        
        // Use the API to update the booking
        await bookingService.updateBooking(bookingId, updatedBookingData);
        
        // If booking has a group ID, update all bookings in the same group
        if (groupID) {
          try {
            // Get all bookings with the same group ID
            const groupBookings = await getallBookingsWithGroupId(groupID);
            
            if (groupBookings && groupBookings.length > 0) {
              // Update each booking in the group (except the current one)
              for (const booking of groupBookings) {
                if (booking.id !== bookingId) {
                  await bookingService.updateBooking(booking.id, {
                    talentId: selectedTalent,
                    status: selectedbookingoption,
                    costcenter1: selectedCostCenter,
                    costcenter2: selectedCostCentertwo,
                    proposedBy: localStorage.getItem("userEmail"),
                    statusUpdatedAt: new Date().toISOString(),
                    custom_rate: customDayRate ? {
                      value: parseInt(customDayRate),
                      currency: "EUR",
                      per: "day"
                    } : null,
                  });
                }
              }
            }
          } catch (error) {
            console.error("Error updating group bookings:", error);
            alert("Warning: The main booking was updated but there was a problem updating all bookings in the group.");
            return;
          }
        }
        
        // Schedule reminders if needed
        await scheduleReminder();
        
        // Send notification to talent
        await createNotification({
          userId: selectedTalentEmail,
          message: `You have been Proposed for new job`,
          read: false,
          url: "talent/my-invitations",
          bookingId: bookingId,
          createdAt: new Date().toISOString()
        });
        
        // Send email based on booking option
        if (selectedbookingoption === "optioned") {
          if (groupID) {
            const groupBookings = await getallBookingsWithGroupId(groupID);
            if (groupBookings.length > 0) {
              const emailContent = createEmailContentForGroupBooking(groupBookings, choosedTalentAllData);
              await createmail3g(selectedTalentName, allbookingdata, choosedTalentAllData, emailContent);
            } else {
              await createmail3(selectedTalentName, allbookingdata, choosedTalentAllData);
            }
          } else {
            await createmail3(selectedTalentName, allbookingdata, choosedTalentAllData);
          }
        } else {
          if (groupID) {
            const groupBookings = await getallBookingsWithGroupId(groupID);
            if (groupBookings.length > 0) {
              const emailContent = createEmailContentForGroupBooking(groupBookings, choosedTalentAllData);
              await createmail2g(selectedTalentName, allbookingdata, choosedTalentAllData, emailContent);
            } else {
              await createmail2(selectedTalentName, allbookingdata, choosedTalentAllData);
            }
          } else {
            await createmail2(selectedTalentName, allbookingdata, choosedTalentAllData);
          }
        }
        
        navigate("/admin/newallbookings");
      } catch (error) {
        console.error("Error updating booking:", error);
        alert("Failed to update the booking. Please try again.");
      }
    }
    
    setSkipEffect(false);
  };
  
  const createmail4 = async (similarBooking) => {
    try {
      const rate = customDayRate || similarBooking.talentRate;
      
      const emailData = {
      
        to_email: `talents@set-cast.com, booking@set-cast.com, ${localStorage.getItem("userEmail")}, ${similarBooking.talentEmail}`,
        subject: "MODIFICATION",
        content: `
          <h2>Dear ${similarBooking.talentName },</h2>
          <p>there has been a client change for your 1st option. We have changed it as follows</p>
          <p>STATUS: 1ST OPTION</p>
          <p>FUNCTION: ${position || 'Not specified'}</p>
          <p>CLIENT: ${editingbookingCompany || 'Not specified'}</p>
          <p>Set: ${set || 'Not specified'}</p>
          <p>TIME: ${times || 'Not specified'}</p>
          <p>RATE: ${rate || 'Not specified'}</p>
          <p>KPI: ${(() => {
            const kpiValue = kpi;
            if (kpiValue === null || kpiValue === undefined || kpiValue === '') {
              return 'Not specified';
            }
            
            // Handle objects (like location objects that might be in the wrong field)
            if (typeof kpiValue === 'object' && kpiValue !== null) {
              return 'Not specified';
            }
            
            // Convert to number and round to integer
            const numericValue = parseFloat(kpiValue);
            if (!isNaN(numericValue)) {
              return Math.round(numericValue);
            }
            
            // If it's not a valid number, return 'Not specified'
            return 'Not specified';
          })()}</p>
          <p>LOCATION: ${formatLocation(bookinglocation)}</p>
          <p>SETCast contact person: ${localStorage.getItem("userEmail") || 'Not specified'}</p>
                    <p>In case of illness or delay, please send an email directly to the distribution list planning@orendtstudios.com and krank@set-cast.com by 8:00 a.m. at the latest.</p>
          <p>Please make sure to inform Set-Cast and the producer of the production if you need to leave the set early and double check with the producer if the KPI has been reached.</p>
          <p>For questions regarding KPI, shooting schedules, callsheets and briefings, please contact planning@orendtstudios.com.</p>
          <p>Invoice details:</p>
          <p>please upload your invoice in Lano - you could combine several tasks in one invoice</p>
          <p>LEGENDE:</p>
          <p>B28 = Behringstrasse 28a, 22765 Hamburg</p>
          <p>TR4 = Tarpenring 4, 22419 Hamburg</p>
          <p>M= Holy-Allee 3, Metzingen, am Empfang melden</p>
          <p>OSB= Am Rosenkothen 2, 40880 Ratingen</p>
            <p>EB5 = Essener Bogen 5, 22419 Hamburg</p>
          <p>Check all your bookings in <a href="https://app.set-cast.com/talent/my-invitations">https://app.set-cast.com/talent/my-invitations</a></p>
        `
      };
      
      return await emailService.sendEmail(emailData);
    } catch (error) {
      console.error("Error sending email:", error);
      alert(`Email Error:\n${error.message}`);
      throw error;
    }
  };

  const mergeBooking = async (similarBooking) => {
    if (!checkProcessingStatus()) {
      return;
    }
    try {
      // Check if cost centers are selected
      if (!selectedCostCenter || !selectedCostCentertwo) {
        console.error("Cost centers not selected before merge attempt");
        setSelectionNotification("❌ Please select both cost centers before choosing a talent");
        setTimeout(() => setSelectionNotification(null), 3000);
        return;
      }
      
      setSelectionNotification(`⏳ Merging talent ${similarBooking.talentName}...`);
      
      // Update the current booking with the talent from the similar booking
      const updateData = {
        talentId: similarBooking.talentId,
        status: "optioned",
        costcenter1: selectedCostCenter,
        costcenter2: selectedCostCentertwo,
        proposedBy: localStorage.getItem("userEmail"),
        isBeingProcessed: false,
        statusUpdatedAt: new Date().toISOString(),
        custom_rate: customDayRate ? {
          value: parseInt(customDayRate),
          currency: "EUR",
          per: "day"
        } : null,
      };
      
      await bookingService.updateBooking(bookingId, updateData);
      
      // Mark the similar booking as deleted
      await bookingService.updateBooking(similarBooking.id, {
        talentId: null,
        status: "deleted",
      });
      
      // Send notification
      await createmail4(similarBooking, allbookingdata);
      
      await createNotification({
        userId: similarBooking.talentEmail,
        message: `Your job details have been updated`,
        read: false,
        url: "talent/my-bookings-page",
        bookingId: bookingId,
        createdAt: new Date().toISOString()
      });
      
      // Show success notification
      setSelectionNotification(`✅ Talent ${similarBooking.talentName} chosen successfully!`);
      setTimeout(() => {
        setSelectionNotification(null);
        alert("Booking updated successfully!");
        navigate("/admin/newallbookings");
      }, 2000);
    } catch (error) {
      console.error("Error merging bookings:", error);
      setSelectionNotification("❌ Failed to merge bookings. Please try again.");
      setTimeout(() => setSelectionNotification(null), 3000);
      alert("Failed to merge bookings. Please try again.");
    }
  };

  const sortByName = () => {
    setTalents(
      [...talents].sort((a, b) => {
        return sortOrder
          ? a.name.localeCompare(b.name)
          : b.name.localeCompare(a.name);
      })
    );
    setSortOrder(!sortOrder); // Switch the sort order for the next click
  };
  const handleTypeChange = (e) => {
    setSelectedType(e.target.value);
  };
  const handleFunctionChange = (e) => {
    setSelectedFunction(e.target.value);
  };
  useEffect(() => {
    if (startDate === "") {
      document.getElementById("start-date");
    }
    if (endDate === "") {
      document.getElementById("end-date");
    }
  }, [startDate, endDate]);
  const uniqueFunctions = [
    ...new Set(talents.map((talent) => talent.Funktion)),
  ];
  const functionOptions = uniqueFunctions.map((func) => ({
    value: func,
    label: func,
  }));
  const fetchlocations = async () => {
    try {
      // Check if the locations endpoint exists
      try {
        const response = await bookingService.getLocations();
        
        // Log the original response to see what we're getting
        // console.log("Location API response:", response.data);
        
        // Check if response.data exists
        if (response && response.data) {
          // Handle different API response formats
          let locationData = [];
          
          if (Array.isArray(response.data)) {
            // Original format: array of location objects
            locationData = response.data.map(loc => {
              // Extract the location value based on available properties, prioritizing short
              const locationValue = loc.short || loc.name || loc.city || (typeof loc === 'string' ? loc : JSON.stringify(loc));
              // Also store full location object for reference if needed
              return { value: locationValue, originalLoc: loc };
            });
          } else if (response.data.locations && Array.isArray(response.data.locations)) {
            // New format: { locations: [...] }
            locationData = response.data.locations.map(loc => {
              // Extract the location value based on available properties, prioritizing short
              const locationValue = loc.short || loc.name || loc.city || (typeof loc === 'string' ? loc : JSON.stringify(loc));
              // Also store full location object for reference if needed
              return { value: locationValue, originalLoc: loc };
            });
          } else {
            // console.warn("Unexpected location data format:", response.data);
            locationData = [
              { value: "HH", label: "Hamburg" },
              { value: "BER", label: "Berlin" },
              { value: "MUC", label: "Munich" },
              { value: "CGN", label: "Cologne" },
              { value: "FFM", label: "Frankfurt" }
            ];
          }
          
          // Extract just the value for the locations state
          const locationValues = locationData.map(item => item.value).filter(Boolean);
          // console.log("Processed location values:", locationValues);
          setLocations(locationValues);
        } else {
          // console.warn("No location data in response");
          setLocations(["HH", "BER", "MUC", "CGN", "FFM"]);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
        // Fallback: Set some default locations
        setLocations(["HH", "BER", "MUC", "CGN", "FFM"]);
      }
    } catch (error) {
      console.error("Error in fetchlocations:", error);
      setLocations([]);
    }
  };
  // Update formatLocation to prioritize short
  const formatLocation = (location, booking = null) => {
    // For KIND orders (set = "digital Production"), always show K.I.N.D.
    if (booking && booking.set === "digital Production") {
      return 'K.I.N.D.';
    }
    
    if (!location) return 'Unknown Location';
    if (typeof location === 'object') {
      return location.short || location.name || location.city || JSON.stringify(location);
    }
    return location;
  };

  // Create locationOptions from the locations array
  const locationOptions = locations
    .map((location) => ({
      value: location,
      label: location,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  function isCompanyMatch(companies, targetCompany) {
    // Check if companies exists and is an array
    if (!companies || !Array.isArray(companies)) {
      return false;
    }
    
    return companies.some(
      (company) => {
        // Handle different company data structures
        if (typeof company === 'string') {
          // For string comparison, check if target company is contained in the string
          // This handles cases like "Company Name | Additional Info"
          const match = company.toLowerCase().includes(targetCompany.toLowerCase());
          if (match) {
            // console.log(`DEBUG - String match found: "${company}" contains "${targetCompany}"`);
          }
          return match;
        } else if (company && typeof company === 'object') {
          const label = company.label || company.name || '';
          const match = label.toLowerCase().includes(targetCompany.toLowerCase());
          if (match) {
            // console.log(`DEBUG - Object match found: "${label}" contains "${targetCompany}"`);
          }
          return match;
        }
        return false;
      }
    );
  }

  // New function to get the best (lowest) rating for a specific company match
  function getCompanyRating(companies, targetCompany) {
    // Check if companies exists and is an array
    if (!companies || !Array.isArray(companies)) {
      return null;
    }
    
    // Find ALL matching companies and get their ratings
    const matchingRatings = companies
      .filter((company) => {
        // Handle different company data structures
        if (typeof company === 'string') {
          return company.toLowerCase().includes(targetCompany.toLowerCase());
        } else if (company && typeof company === 'object') {
          const label = company.label || company.name || '';
          return label.toLowerCase().includes(targetCompany.toLowerCase());
        }
        return false;
      })
      .map((company) => {
        // Extract rating from matched company
        if (typeof company === 'object' && company.rating) {
          return company.rating;
        }
        return null;
      })
      .filter((rating) => rating !== null && rating !== undefined);
    
    // Return the best (lowest) rating if any ratings found
    if (matchingRatings.length > 0) {
      return Math.min(...matchingRatings);
    }
    
    return null;
  }
  function getPerformanceRanking(talent, editingBookingCompanyLower) {
    // Handle case where talent or editingBookingCompanyLower is undefined
    if (!talent || !editingBookingCompanyLower) {
      return { category: 3, rating: null }; // Default ranking
    }
    
    // Safely check if these properties exist and are arrays or objects
    const isGoodMatch = isCompanyMatch(
      talent.goodPerformanceCompany,
      editingBookingCompanyLower
    );
    const isTryoutMatch = isCompanyMatch(
      talent.tryOutCompany,
      editingBookingCompanyLower
    );
    const isBadMatch = isCompanyMatch(
      talent.badPerformanceCompany,
      editingBookingCompanyLower
    );

    // Assign rankings based on priority, including rating for good performers
    if (isGoodMatch) {
      const rating = getCompanyRating(talent.goodPerformanceCompany, editingBookingCompanyLower);
      // console.log(`DEBUG - ${talent.Name}: Good match for "${editingBookingCompanyLower}", rating: ${rating}`);
      // console.log(`DEBUG - ${talent.Name}: Good performance companies:`, talent.goodPerformanceCompany);
      return { category: 1, rating: rating || 999 }; // Good performers, rating 1 first, 2 second, 3 third, then unrated
    }
    if (isTryoutMatch) {
      // console.log(`DEBUG - ${talent.Name}: Tryout match for ${editingBookingCompanyLower}`);
      return { category: 2, rating: null }; // Try-out performers get second priority
    }
    if (isBadMatch) {
      // console.log(`DEBUG - ${talent.Name}: Bad match for ${editingBookingCompanyLower}`);
      return { category: 4, rating: null };    // Bad performers get lowest priority
    }
    // console.log(`DEBUG - ${talent.Name}: No match for ${editingBookingCompanyLower}`);
    return { category: 3, rating: null };                    // No match for good or tryout
  }

  // Enhanced sorting function to prioritize good performers with rating-based sub-sorting
  const sortTalentsByPerformance = (talents, editingBookingCompanyLower) => {
    return [...talents].sort((a, b) => {
      // Get performance rankings for both talents
      const aRanking = getPerformanceRanking(a, editingBookingCompanyLower);
      const bRanking = getPerformanceRanking(b, editingBookingCompanyLower);
      
      // First priority: Performance category (1=good, 2=tryout, 3=no match, 4=bad)
      if (aRanking.category !== bRanking.category) {
        return aRanking.category - bRanking.category; // Lower number = higher priority
      }
      
      // Second priority: For good performers (category 1), sort by rating
      if (aRanking.category === 1 && bRanking.category === 1) {
        // Both are good performers, sort by rating (1 first, 2 second, 3 third, then unrated=999)
        if (aRanking.rating !== bRanking.rating) {
          return aRanking.rating - bRanking.rating; // Lower rating number = higher priority
        }
      }
      
      // Third priority: If categories and ratings are the same, sort by name (alphabetical)
      if (a.Name && b.Name) {
        return a.Name.localeCompare(b.Name);
      }
      
      return 0;
    });
  };

  // Render company list - handles different formats
  const renderCompanyList = (companies) => {
    if (!companies || (!Array.isArray(companies) && typeof companies !== 'object')) {
      return '';
    }
    
    if (Array.isArray(companies)) {
      // Handle both array of strings and array of objects
      return companies.map(company => {
        if (typeof company === 'string') {
          return company;
        } else if (company && typeof company === 'object') {
          const companyName = company.label || company.name || '';
          const rating = company.rating ? ` (Rating ${company.rating})` : '';
          return `${companyName}${rating}`;
        }
        return '';
      }).filter(Boolean).join(', ');
    }
    
    // Handle case where it might be a single object
    if (typeof companies === 'object') {
      const companyName = companies.label || companies.name || '';
      const rating = companies.rating ? ` (Rating ${companies.rating})` : '';
      return `${companyName}${rating}`;
    }
    
    return '';
  };

  return (
    <div className="content-wrapper page">
      {isProcessing && processingUser !== localStorage.getItem("userEmail") && (
        <div style={{
          position: "fixed",
          top: "20px",
          right: "20px",
          backgroundColor: "#ff6b6b",
          color: "white",
          padding: "10px 20px",
          borderRadius: "4px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
          zIndex: 1000
        }}>
          This booking is being processed by {processingUser}
        </div>
      )}
      <div>
        <h1>{bookingId ? "Propose Talent" : "Create Booking"}</h1>
      </div>
      <div
        style={{
          marginTop: "60px",
        }}
      >
        {bookingId ? (
          // If bookingId exists, render your 'editing' JSX here, example:
          <div>
            <div className="content-wrapper-talent-list">
              <div
                className="task-info"
                //style={{ backgroundColor: groupColor, color: groupColor ? "#fff" : "inherit" }}
              >
                <h2 style={{ marginBottom: "20px" }}>order details</h2>
                <div
                  style={{
                    display: "flex",
                    gap: "80px",
                    marginBottom: "40px",
                    fontSize: "1.2rem",
                    lineHeight: "1.5",
                  }}
                >
                  <div>
                    <div style={{ fontWeight: "300", fontSize: "1rem" }}>
                      Client
                    </div>
                    <b style={{ marginBottom: "10px", display: "block" }}>
                      {editingbookingCompany}
                    </b>
                  </div>
                  <div>
                    <div style={{ fontWeight: "300", fontSize: "1rem" }}>
                      KPI
                    </div>
                    <b style={{ marginBottom: "10px", display: "block" }}>
                      {kpi}
                    </b>
                  </div>
                  <div>
                    <div style={{ fontWeight: "300", fontSize: "1rem" }}>
                      Date
                    </div>
                    <b style={{ marginBottom: "10px", display: "block" }}>
                      {startDate}{" "}
                    </b>
                  </div>
                  <div>
                    <div style={{ fontWeight: "300", fontSize: "1rem" }}>
                      Time
                    </div>
                    <b style={{ marginBottom: "10px", display: "block" }}>
                      {times}
                    </b>
                  </div>
                  <div>
                    <div style={{ fontWeight: "300", fontSize: "1rem" }}>
                      Set
                    </div>
                    <b style={{ marginBottom: "10px", display: "block" }}>
                      {set}
                    </b>
                  </div>
                  <div>
                    <div style={{ fontWeight: "300", fontSize: "1rem" }}>
                      Position
                    </div>
                    <b style={{ marginBottom: "10px", display: "block" }}>
                      {position}
                    </b>
                  </div>
                  <div>
                    <div style={{ fontWeight: "300", fontSize: "1rem" }}>
                      Location
                    </div>
                    <b style={{ marginBottom: "10px", display: "block" }}>
                      {formatLocation(bookinglocation)}
                    </b>
                  </div>
                </div>
                <div>
                  {samegroupbooking.length > 0 ? (
                    <h3 style={{ marginBottom: "20px" }}>
                      Also proposing for these group orders
                    </h3>
                  ) : (
                    <></>
                  )}
                  <div className="group-tasks propose-list">
                    <ul>
                      {samegroupbooking.map((booking) => (
                        <li key={booking.id}>
                          <div
                            style={{
                              display: "flex",
                              gap: "80px",
                              paddingBottom: "10px",
                              fontSize: "1.2rem",
                              lineHeight: "1.5",
                            }}
                          >
                            <div style={{ width: "350px" }}>
                              {booking.client?.label || 'Unknown Client'}
                            </div>
                            <div style={{ width: "200px" }}>
                              {booking.position?.label || 'Unknown Position'}
                            </div>
                            <div style={{ width: "50px" }}>{booking.kpi || ''}</div>
                            <div style={{ width: "100px" }}>
                              {(() => {
                                try {
                                  if (booking.start_date) {
                                    const date = new Date(booking.start_date);
                                    return date.toLocaleDateString();
                                  }
                                  return 'N/A';
                                } catch (error) {
                                  console.error('Error formatting date:', error);
                                  return 'Date Error';
                                }
                              })()}
                            </div>
                            <div style={{ width: "150px" }}>
                              {booking.start_time || booking.startTime || '00:00'}-{booking.end_time || booking.endTime || '00:00'}
                            </div>
                            <div style={{ width: "150px" }}>
                              {formatLocation(booking.location, booking)}
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="notificaion-infos">
                <h2 style={{ marginTop: "30px" }}>Notifications</h2>
                <div
                  className="notification-checkboxes"
                  style={{
                    marginTop: "10px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <div className="custom-checkbox">
                    <input
                      type="checkbox"
                      id="checkbox-1"
                      checked={isChecked1}
                      onChange={() => setIsChecked1(!isChecked1)}
                    />
                    <label htmlFor="checkbox-1"></label>
                  </div>
                  <div className="checkbox-label">Inform Talent</div>

                  <div className="custom-checkbox">
                    <input
                      type="checkbox"
                      id="checkbox-2"
                      checked={isChecked2}
                      onChange={() => setIsChecked2(!isChecked2)}
                    />
                    <label htmlFor="checkbox-2"></label>
                  </div>
                  <div className="checkbox-label">Inform planing</div>
                  <div className="custom-checkbox">
                    <input
                      type="checkbox"
                      id="checkbox-3"
                      checked={isChecked3}
                      onChange={() => setIsChecked3(!isChecked3)}
                    />
                    <label htmlFor="checkbox-3"></label>
                  </div>
                  <div className="checkbox-label">Inform me</div>

                  <div className="datepicker-wrapper">
                    <DatePicker
                      selected={scheduledTime}
                      onChange={(date) => setScheduledTime(date)}
                      showTimeSelect
                      filterTime={isTimeIn30MinInterval}
                      filterDate={filterPassedTime}
                      minTime={minTime}
                      maxTime={maxTime}
                      dateFormat="MMMM d, yyyy h:mm aa"
                    />
                  </div>
                </div>
              </div>
              <div className="task-info">
                <div
                  style={{
                    fontSize: "1.2rem",
                    lineHeight: "1.5",
                    maxWidth: "500px",
                  }}
                >
                  <h2 style={{ marginBottom: "20px" }}>select costcenters</h2>
                  <div
                    className="propose-selectors"
                    style={{ display: "flex", gap: "10px" }}
                  >
                    
                    <div>
                      <Select
                        components={{ DropdownIndicator }}
                        options={constcenter1}
                        onChange={handleSelectCostCenter}
                        placeholder="CostCenter 1"
                        value={selectedCostCenter}
                        styles={customStyles}
                        required
                      />
                    </div>
                    <div>
                      <Select
                        components={{ DropdownIndicator2 }}
                        options={constcenter2}
                        onChange={handleSelectCostCentertwo}
                        placeholder="CostCenter 2"
                        value={selectedCostCentertwo}
                        styles={customStyles}
                        required
                      />
                    </div>
                  </div>
                  <div className="custom-checkbox"   style={{
                    marginTop: "00px",
                    display: "flex",
                    alignItems: "center",
                  }}>
                    <input
                      type="checkbox"
                      id="checkbox-4"
                      checked={customDayRateCheck}
                      onChange={() => setCustomDayRateCheck(!customDayRateCheck)}
                    />
                    <label htmlFor="checkbox-4">      </label>
                    <div className="checkbox-label " style={{
                    marginTop: "30px",
                    display: "flex",
                    alignItems: "center",
                  }}>Special Rate</div>
                  </div>
            
                  {customDayRateCheck ? <>
                  <span className="talent-item-input-title">Custom Rate in euro - only numbers</span>
                    <input
                      className="inputtext"
                      value={customDayRate}
                      onChange={(e) => {
                        // Use a regular expression to allow only numbers
                        const value = e.target.value;
                        const regex = /^[0-9]*$/;
                        
                        if (regex.test(value)) {
                          setCustomDayRate(value);
                        }
                      }}
                    /></>
                    : <></>}
                </div>
              </div>
              {similarBookings.length === 0 ? (
                <div></div>
              ) : (
                <div className="task-info">
                  <h3 style={{ marginBottom: "10px" }}>
                    Similar reserved talent
                  </h3>
                  {similarBookings.map((booking) => {
                    // Get location info with better handling for missing/null values
                    const bookingLocation = booking.location?.short || booking.location?.name || booking.location;
                    const locationDisplay = bookingLocation || 'N/A';
                    const isLocationMissing = !bookingLocation || bookingLocation === 'N/A' || bookingLocation === 'null' || bookingLocation === '';
                    
                    return (
                      <div
                        style={{ 
                          fontSize: "1.2rem", 
                          lineHeight: "1.5",
                          padding: "10px",
                          margin: "5px 0",
                          backgroundColor: isLocationMissing ? "#fff3cd" : "#f8f9fa",
                          border: isLocationMissing ? "1px solid #ffeaa7" : "1px solid #dee2e6",
                          borderRadius: "4px"
                        }}
                        key={booking.id}
                      >
                        <strong>{booking.client?.label || 'Unknown Client'}</strong> - {booking.position?.label || 'Unknown Position'} -{" "}
                        <strong>{booking.talentName || 'Unknown'}</strong> - {booking.talentEmail || 'No Email'} -{" "}
                        {(() => {
                          try {
                            if (booking.start_date) {
                              const date = new Date(booking.start_date);
                              return date.toLocaleDateString();
                            }
                            return 'N/A';
                          } catch (error) {
                            console.error('Error formatting date:', error);
                            return 'Date Error';
                          }
                        })()} {" "}
                        {booking.startTime || '00:00'}- {booking.endTime || '00:00'} -{" "}
                        <span style={{ 
                          color: isLocationMissing ? "#856404" : "inherit",
                          fontStyle: isLocationMissing ? "italic" : "normal"
                        }}>
                          Location: {locationDisplay}
                        </span>
                      <button
                        style={{ 
                          marginLeft: "20px",
                          padding: "8px 16px",
                          backgroundColor: "#37b24d",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          cursor: "pointer",
                          fontWeight: "bold"
                        }}
                        onClick={() => {
                          mergeBooking(booking);
                        }}
                      >
                        Choose Talent
                      </button>
                    </div>
                  );
                })}
                </div>
              )}
              
              {selectedTalent === null ? (
                <>
                  <div className="content-wrapper">
                    <h2 style={{ marginTop: "40px", marginBottom: "20px" }}>
                      select talent
                    </h2>
                    <div
                      className="propose-selectors"
                      style={{ display: "flex", gap: "10px" }}
                    >
                      <input
                        type="text"
                        placeholder="Search..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="inputtext search"
                      />
                      <Select
                        value={locationOptions.find(
                          (option) => option.value === selectLocations
                        )}
                        onChange={(option) => {
                          const locationValue = option ? option.value : "";
                          // console.log("Selected location:", locationValue);
                          setSelectedLocations(locationValue);
                        }}
                        options={locationOptions}
                        isClearable
                        placeholder="Select location"
                        styles={customStyles}
                      />

                      <Select
                        value={functionOptions.find(
                          (option) => option.value === selectedFunction
                        )}
                        onChange={(option) =>
                          setSelectedFunction(option ? option.value : "")
                        }
                        options={functionOptions}
                        isClearable
                        placeholder="Select Function"
                        styles={customStyles}
                      />
                    </div>
                  </div>
                  <div className="content-wrapper content-wrapper-talent-list">
                    <div style={{ maxWidth: "100%", marginTop: "40px" }}>
                      <div
                        className="propose-item-header"
                        style={{ maxWidth: "100%" }}
                      >
                        <div style={{ flexBasis: "300px" }}>name</div>
                        <div style={{ flexBasis: "200px" }}>function</div>
                        <div style={{ flexBasis: "200px" }}>type</div>
                        <div style={{ flexBasis: "200px" }}>rate</div>
                        <div style={{ flexBasis: "300px" }}>good Performer</div>
                        <div style={{ flexBasis: "300px" }}>Try out</div>
                        <div style={{ flexBasis: "300px" }}>bad Performer</div>

                        <div style={{ flexBasis: "80px" }}></div>
                      </div>
                      <div className="propose-list">
                        {talents.length === 0 && <div className="no-data">No talents found. Try adjusting your filters.</div>}
                        {(() => {
                          const filteredTalents = talents.filter((talent) => {
                            const searchLowerCase = search?.toLowerCase() || '';

                            // Safely handle type checking and null/undefined values for various fields
                            const safeString = (value) => typeof value === 'string' ? value.toLowerCase() : '';
                            
                            // For KIND orders (set = "digital Production"), don't filter by Bereich/set
                            // KIND orders should only filter by function/position
                            const isKindOrder = set === "digital Production";
                            
                            // Don't filter by set/Bereich if we want to see all talents, or if it's a KIND order
                            const setMatch = !set || isKindOrder || (selectedFunction === '' && selectLocations === '') ? true : 
                              (talent.Bereich && safeString(talent.Bereich) === set.toLowerCase());
                            
                            // Safe check for function match
                            const functionMatch = !selectedFunction ? true : 
                              (talent.Funktion && talent.Funktion === selectedFunction);
                            
                            // Debug logging for KIND orders
                            if (isKindOrder && talent.Funktion === "AI Content Production") {
                              // console.log("KIND order talent check:", {
                                // name: talent.Name,
                                // funktion: talent.Funktion,
                                // bereich: talent.Bereich,
                                // setMatch,
                                // functionMatch,
                                // passed: setMatch && functionMatch
                              // });
                            }
                            
                            // Safe check for location match
                            const locationMatch = !selectLocations ? true : 
                              (talent.locations && Array.isArray(talent.locations) ? 
                                talent.locations.some((location) => {
                                  if (!location) return false;
                                  
                                  // If location is a string
                                  if (typeof location === 'string') {
                                    return location === selectLocations;
                                  }
                                  
                                  // If location has short property (preferred)
                                  if (location.short) {
                                    return location.short === selectLocations;
                                  }
                                  
                                  // Fall back to other properties
                                  if (location.value) return location.value === selectLocations;
                                  if (location.name) return location.name === selectLocations;
                                  
                                  // If location itself is the value
                                  return location === selectLocations;
                                }) : 
                                // If locations is a string
                                typeof talent.locations === 'string' ? talent.locations === selectLocations : false);
                            
                            // Safe check for search match across multiple fields
                            const searchMatch = !searchLowerCase ? true : (
                              (talent.Name && safeString(talent.Name).includes(searchLowerCase)) ||
                              (talent.Funktion && safeString(talent.Funktion).includes(searchLowerCase)) ||
                              (talent.E_Mail && safeString(talent.E_Mail).includes(searchLowerCase)) ||
                              (talent.Gage && safeString(talent.Gage).includes(searchLowerCase)) ||
                              (talent.Notiz_Setcast && safeString(talent.Notiz_Setcast).includes(searchLowerCase)) ||
                              (talent.Tagessatz && safeString(talent.Tagessatz).includes(searchLowerCase)) ||
                              (talent.Telefon && safeString(talent.Telefon).includes(searchLowerCase)) ||
                              (talent.Verifizierung && safeString(talent.Verifizierung).includes(searchLowerCase)) ||
                              (talent.Bereich && safeString(talent.Bereich).includes(searchLowerCase))
                            );
                            
                            return setMatch && functionMatch && locationMatch && searchMatch;
                          });
                          
                          const isKindOrder = set === "digital Production";
                          if (isKindOrder) {
                            // console.log(`🎯 KIND Order filtering: Showing ${filteredTalents.length} of ${talents.length} talents`);
                            // console.log(`Filter criteria: Function="${selectedFunction}", Location="${selectLocations}", Set="${set}"`);
                          } else {
                            // console.log(`Showing ${filteredTalents.length} of ${talents.length} talents after filtering`);
                          }
                          
                          return sortTalentsByPerformance(
                            filteredTalents,
                          editingbookingCompany?.toLowerCase() || ''
                        ).map((talent, index) => (
                          <div 
                            key={`talent-item-${talent.value || index}`}
                            className={isTalentSelected(talent.value) ? "selected-talent-row" : ""}
                          >
                            <div>
                              <div className="propose-item" style={isTalentSelected(talent.value) ? selectedTalentStyle : {}}>
                                <div style={{ flexBasis: "300px" }}>
                                  {talent.Name}
                                </div>
                                <div style={{ flexBasis: "200px" }}>
                                  {talent.Funktion}
                                </div>
                                <div style={{ flexBasis: "200px" }}>
                                  {talent.Bereich}
                                </div>
                                <div style={{ flexBasis: "200px" }}>
                                  {talent.Tagessatz}
                                </div>
                                {/* Good Performers */}
                                <div style={{ flexBasis: "300px", color: "green" }}>
                                  {renderCompanyList(talent.goodPerformanceCompany)}
                                </div>
                                {/* Try Out */}
                                <div style={{ flexBasis: "300px" }}>
                                  {renderCompanyList(talent.tryOutCompany)}
                                </div>
                                {/* Bad Performers */}
                                <div style={{ flexBasis: "300px", color: "red" }}>
                                  {renderCompanyList(talent.badPerformanceCompany)}
                                </div>
                                <div style={{ flexBasis: "80px", display: "flex", gap: "8px" }}>
                               
                                  <button
                                    className="edit-buttons"
                                    style={{
                                      padding: "4px 8px",
                                      backgroundColor: selectedTalentdet === talent.value ? "#ff6b6b" : "#4dabf7",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      width: "30px",
                                      height: "30px"
                                    }}
                                    onClick={() => {
                                      if (selectedTalentdet === talent.value) {
                                        setSelectedTalentdet(null);
                                      } else {
                                        setSelectedTalentdet(talent.value);
                                      }
                                    }}
                                    title={selectedTalentdet === talent.value ? "Close Calendar" : "Open Calendar"}
                                    dangerouslySetInnerHTML={{ 
                                      __html: selectedTalentdet === talent.value ? SVG_ICONS.close : SVG_ICONS.calendar 
                                    }}
                                  >
                                  </button>
                                  
                                  {/* Select Button */}
                                  <button
                                    className="edit-buttons"
                                    style={{
                                      padding: "4px 8px",
                                      backgroundColor: "#37b24d",
                                      color: "white",
                                      border: "none",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      width: "30px", 
                                      height: "30px"
                                    }}
                                    onClick={() => {
                                      setSelectedTalent(talent.value);
                                      setSelectedTalentName(talent.Name);
                                      setSelectedTalentEmail(talent.E_Mail);
                                      setchoosedTalentAllData(talent.alldata);
                                      
                                      // Show notification
                                      setSelectionNotification(`✅ Talent "${talent.Name}" selected successfully!`);
                                      setTimeout(() => setSelectionNotification(null), 3000); // Hide after 3 seconds
                                      
                                      window.scrollTo(0, 0); // Scroll to top to show the selected talent section
                                    }}
                                    title="Select This Talent"
                                    dangerouslySetInnerHTML={{ __html: SVG_ICONS.select }}
                                  >
                                  </button>
                                </div>
                              </div>
                            </div>
                            {selectedTalentdet === talent.value && (
                              <div
                                className="calendar"
                                style={{
                                  marginLeft: "20px",
                                  marginRight: "20px",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "20px",
                                }}
                              >
                                <TalentCalendarApi
                                  talentId={talent.value}
                                  relatedTalents={talent.relatedTalent}
                                  initialDate={startDate ? new Date(startDate) : new Date()}
                                />
                              </div>
                            )}
                          </div>
                        ))})()}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="content-wrapper" style={{marginBottom: '20px'}}>
                    <div
                      style={{
                        fontWeight: "700",
                        fontSize: "2rem",
                        marginTop: "20px",
                        marginBottom: "20px",
                      }}
                    >
                      <div
                        style={{
                          fontWeight: "300",
                          fontSize: "1rem",
                          marginBottom: "5px",
                        }}
                      >
                        Selected Talent
                      </div>
                      {selectedTalentName}
                    </div>
                    <Select
                      components={{ DropdownIndicator2 }}
                      options={booking}
                      onChange={hadleSelectedBookingOption}
                      placeholder="status"
                    //  value={booking.option}
                      styles={customStyles}
                    />
                  </div>
            
                  <div className="content-wrapper">
                    <div className="button-wrapper">
                   
                      <button className="big-button" onClick={handleSubmit}>
                        {(selectedbookingoption == "optioned") ? "Propose" :"Request nehmen"}
                      </button>{" "}
                      <button
                        className="big-button"
                        onClick={() => {
                          setSelectedTalent(null);
                        }}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        ) : (
          <>
            <div>Nothing to show</div>
          </>
        )}
      </div>
      {selectionNotification && (
        <div style={{
          position: "fixed",
          top: "20px",
          right: "20px",
          backgroundColor: "#37b24d",
          color: "white",
          padding: "10px 20px",
          borderRadius: "4px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
          zIndex: 1000,
          maxWidth: "300px"
        }}>
          {selectionNotification}
        </div>
      )}
    </div>
  );
}
export default ProposeTalentsBookingDetail;
